module.exports = __webpack_public_path__ + "puxiimg3.png?625529f02fb73a32e3e0ba733e4a6706";